export default __webpack_public_path__ + "static/media/dc-superman.e9391474.jpg";